import PageHero from "@/components/PageHero";
import { Reveal } from "@/components/Reveal";
import EnquiryForm from "@/components/EnquiryForm";
import { SEEDBANK_STEPS } from "@/data/academy";

export default function SeedBanks() {
  return (
    <div data-testid="seedbanks-page">
      <PageHero
        kicker="Seed banks"
        title="A seed bank should begin with what it needs to make possible."
        subtitle="We don't begin by selling infrastructure. We first determine the on-country purpose, likely users, species priorities, restoration needs and long-term operational capacity."
        image="https://customer-assets.emergentagent.com/job_academy-2/artifacts/67s6tt6s_seedkeepers%2013.webp"
      />

      <section className="bg-cream py-24 md:py-32">
        <div className="max-w-[1100px] mx-auto px-6 md:px-12">
          <Reveal className="mb-14 max-w-2xl">
            <p className="overline text-ochre mb-6">The process</p>
            <h2 className="font-serif text-4xl md:text-5xl font-light text-charcoal leading-tight">Designed from the outside in.</h2>
          </Reveal>

          {SEEDBANK_STEPS.map((s, i) => (
            <Reveal key={s.n} delay={(i % 2) * 0.05}>
              <div className="grid grid-cols-1 md:grid-cols-[110px_1fr] gap-6 md:gap-14 items-start border-t border-charcoal/12 py-9">
                <span className="font-serif text-5xl md:text-6xl text-copper leading-none">{s.n}</span>
                <div>
                  <h3 className="font-serif text-2xl md:text-3xl text-rainforest mb-3">{s.title}</h3>
                  <p className="text-charcoal/70 text-lg font-light leading-relaxed max-w-2xl">{s.body}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </section>

      <section className="bg-sandstone py-20 md:py-28">
        <div className="max-w-[1100px] mx-auto px-6 md:px-12">
          <Reveal>
            <p className="font-serif text-2xl md:text-4xl font-light leading-snug text-rainforest max-w-4xl">
              The result may be a modest community seed store, a working collection and processing
              facility, a regional conservation collection or a larger seed supply hub. The right
              model is the one that can be maintained, used and carried forward by the people
              responsible for it.
            </p>
          </Reveal>
        </div>
      </section>

      <section className="bg-cream py-24 md:py-32" data-testid="seedbank-enquiry">
        <div className="max-w-[900px] mx-auto px-6 md:px-12">
          <Reveal className="mb-10 text-center">
            <p className="overline text-ochre mb-4">Discuss your seed bank</p>
            <h2 className="font-serif text-4xl md:text-5xl font-light text-charcoal">Start with purpose.</h2>
          </Reveal>
          <Reveal><EnquiryForm formType="seed-bank" title="Seed bank enquiry" cta="Discuss Your Seed Bank" /></Reveal>
        </div>
      </section>
    </div>
  );
}
